// Hook for filling form fields with enrichment results even when an input is focused.
//
// LiveView's DOM patcher skips updating the `value` of the currently focused
// input, so server-side enrichment results are lost when the user tabs directly
// to a field before the async task completes. This hook bypasses that by reading
// enriched values from data attributes on the *form* element (which is never the
// focused element) and applying them to empty inputs.
export const FillEnrichedFields = {
  updated() {
    const fill = (dataKey, inputName) => {
      const value = this.el.dataset[dataKey]
      if (!value) return
      const input = this.el.querySelector(
        `[name="account_broker[${inputName}]"]`,
      )
      if (input && !input.value) {
        input.value = value
        input.dispatchEvent(new Event("input", { bubbles: true }))
      }
    }
    fill("enrichedFirstName", "first_name")
    fill("enrichedLastName", "last_name")
    fill("enrichedBrokerage", "brokerage")
  },
}
